import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'kbm-messages',
    standalone: true,
    imports: [
        NgClass
    ],
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss']
})
export class MessagesComponent {
  messageService = inject(MessageService);

  message = this.messageService.message;

  onClose() {
    this.messageService.clear();
  }

}
